export const ENTITY_DATA_TYPE = "ENTITY";
export const ALLOWED_DATA_TYPES = ["STRING", "LONG", "BOOLEAN", "DATETIME", "ENTITY", "DOUBLE", "DATE", "NA"];
